// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-btn {
  align-items: center;
  border-radius: 4px;
  display: inline-grid;
  grid-template-areas: "prepend content append";
  grid-template-columns: max-content auto max-content;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.0892857143em;
  line-height: normal;
  max-width: 100%;
  outline: none;
  position: relative;
  text-decoration: none;
  text-indent: 0.0892857143em;
  text-transform: uppercase;
  transition-property: box-shadow, transform, opacity, background;
  transition-duration: 0.28s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  vertical-align: middle;
  flex-shrink: 0;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
.v-btn--size-x-small {
  --v-btn-size: 0.625rem;
  --v-btn-height: 20px;
  font-size: var(--v-btn-size);
  min-width: 36px;
  padding: 0 8px;
}

.v-btn--size-small {
  --v-btn-size: 0.75rem;
  --v-btn-height: 28px;
  font-size: var(--v-btn-size);
  min-width: 50px;
  padding: 0 12px;
}

.v-btn--size-default {
  --v-btn-size: 0.875rem;
  --v-btn-height: 36px;
  font-size: var(--v-btn-size);
  min-width: 64px;
  padding: 0 16px;
}

.v-btn--size-large {
  --v-btn-size: 1rem;
  --v-btn-height: 44px;
  font-size: var(--v-btn-size);
  min-width: 78px;
  padding: 0 20px;
}

.v-btn--size-x-large {
  --v-btn-size: 1.125rem;
  --v-btn-height: 52px;
  font-size: var(--v-btn-size);
  min-width: 92px;
  padding: 0 24px;
}

.v-btn.v-btn--density-default {
  height: calc(var(--v-btn-height) + 0px);
}

.v-btn.v-btn--density-comfortable {
  height: calc(var(--v-btn-height) + -8px);
}

.v-btn.v-btn--density-compact {
  height: calc(var(--v-btn-height) + -12px);
}

.v-btn--border {
  border-width: thin;
  box-shadow: none;
}
.v-btn--absolute {
  position: absolute;
}
.v-btn--fixed {
  position: fixed;
}
.v-btn:hover > .v-btn__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
.v-btn:focus-visible > .v-btn__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  .v-btn:focus > .v-btn__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
.v-btn--active > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true] > .v-btn__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
.v-btn--active:hover > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true]:hover > .v-btn__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
.v-btn--active:focus-visible > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-btn__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  .v-btn--active:focus > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true]:focus > .v-btn__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}
.v-btn--variant-plain, .v-btn--variant-outlined, .v-btn--variant-text, .v-btn--variant-tonal {
  background: transparent;
  color: inherit;
}
.v-btn--variant-plain {
  opacity: 0.62;
}
.v-btn--variant-plain:focus, .v-btn--variant-plain:hover {
  opacity: 1;
}
.v-btn--variant-plain .v-btn__overlay {
  display: none;
}
.v-btn--variant-elevated, .v-btn--variant-flat {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
.v-btn--variant-elevated {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
.v-btn--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
.v-btn--variant-outlined {
  border: thin solid currentColor;
}
.v-btn--variant-text .v-btn__overlay {
  background: currentColor;
}
.v-btn--variant-tonal .v-btn__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
@supports selector(:focus-visible) {
  .v-btn::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    border: 2px solid currentColor;
    border-radius: inherit;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  .v-btn:focus-visible::after {
    opacity: calc(0.25 * var(--v-theme-overlay-multiplier));
  }
}
.v-btn--icon {
  border-radius: 50%;
  min-width: 0;
  padding: 0;
}
.v-btn--icon.v-btn--size-default {
  --v-btn-size: 1rem;
}
.v-btn--icon.v-btn--density-default {
  width: calc(var(--v-btn-height) + 12px);
  height: calc(var(--v-btn-height) + 12px);
}
.v-btn--icon.v-btn--density-comfortable {
  width: calc(var(--v-btn-height) + 0px);
  height: calc(var(--v-btn-height) + 0px);
}
.v-btn--icon.v-btn--density-compact {
  width: calc(var(--v-btn-height) + -8px);
  height: calc(var(--v-btn-height) + -8px);
}

.v-btn--elevated:hover, .v-btn--elevated:focus {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
.v-btn--elevated:active {
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
.v-btn--flat {
  box-shadow: none;
}
.v-btn--block {
  display: flex;
  flex: 1 0 auto;
  min-width: 100%;
}
.v-btn--disabled {
  pointer-events: none;
  opacity: 0.26;
}
.v-btn--disabled:hover {
  opacity: 0.26;
}
.v-btn--disabled.v-btn--variant-elevated, .v-btn--disabled.v-btn--variant-flat {
  box-shadow: none;
  opacity: 1;
  color: rgba(var(--v-theme-on-surface), 0.26);
  background: rgb(var(--v-theme-surface));
}
.v-btn--disabled.v-btn--variant-elevated .v-btn__overlay, .v-btn--disabled.v-btn--variant-flat .v-btn__overlay {
  opacity: 0.4615384615;
}
.v-btn--loading {
  pointer-events: none;
}
.v-btn--loading .v-btn__content,
.v-btn--loading .v-btn__prepend,
.v-btn--loading .v-btn__append {
  opacity: 0;
}
.v-btn--stacked {
  grid-template-areas: "prepend" "content" "append";
  grid-template-columns: auto;
  grid-template-rows: max-content max-content max-content;
  justify-items: center;
  align-content: center;
}
.v-btn--stacked .v-btn__content {
  flex-direction: column;
  line-height: 1.25;
}
.v-btn--stacked .v-btn__prepend,
.v-btn--stacked .v-btn__append,
.v-btn--stacked .v-btn__content > .v-icon--start,
.v-btn--stacked .v-btn__content > .v-icon--end {
  margin-inline: 0;
}
.v-btn--stacked .v-btn__prepend,
.v-btn--stacked .v-btn__content > .v-icon--start {
  margin-bottom: 4px;
}
.v-btn--stacked .v-btn__append,
.v-btn--stacked .v-btn__content > .v-icon--end {
  margin-top: 4px;
}
.v-btn--stacked.v-btn--size-x-small {
  --v-btn-size: 0.625rem;
  --v-btn-height: 56px;
  font-size: var(--v-btn-size);
  min-width: 56px;
  padding: 0 12px;
}

.v-btn--stacked.v-btn--size-small {
  --v-btn-size: 0.75rem;
  --v-btn-height: 64px;
  font-size: var(--v-btn-size);
  min-width: 64px;
  padding: 0 14px;
}

.v-btn--stacked.v-btn--size-default {
  --v-btn-size: 0.875rem;
  --v-btn-height: 72px;
  font-size: var(--v-btn-size);
  min-width: 72px;
  padding: 0 16px;
}

.v-btn--stacked.v-btn--size-large {
  --v-btn-size: 1rem;
  --v-btn-height: 80px;
  font-size: var(--v-btn-size);
  min-width: 80px;
  padding: 0 18px;
}

.v-btn--stacked.v-btn--size-x-large {
  --v-btn-size: 1.125rem;
  --v-btn-height: 88px;
  font-size: var(--v-btn-size);
  min-width: 88px;
  padding: 0 20px;
}

.v-btn--stacked.v-btn--density-default {
  height: calc(var(--v-btn-height) + 0px);
}

.v-btn--stacked.v-btn--density-comfortable {
  height: calc(var(--v-btn-height) + -16px);
}

.v-btn--stacked.v-btn--density-compact {
  height: calc(var(--v-btn-height) + -24px);
}

.v-btn--slim {
  padding: 0 8px;
}
.v-btn--rounded {
  border-radius: 24px;
}
.v-btn--rounded.v-btn--icon {
  border-radius: 4px;
}
.v-btn .v-icon {
  --v-icon-size-multiplier: 0.8571428571;
}
.v-btn--icon .v-icon {
  --v-icon-size-multiplier: 1;
}
.v-btn--stacked .v-icon {
  --v-icon-size-multiplier: 1.1428571429;
}

.v-btn__loader {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.v-btn__content,
.v-btn__prepend,
.v-btn__append {
  align-items: center;
  display: flex;
  transition: transform, opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-btn__prepend {
  grid-area: prepend;
  margin-inline: calc(var(--v-btn-height) / -9) calc(var(--v-btn-height) / 4.5);
}

.v-btn__append {
  grid-area: append;
  margin-inline: calc(var(--v-btn-height) / 4.5) calc(var(--v-btn-height) / -9);
}

.v-btn__content {
  grid-area: content;
  justify-content: center;
  white-space: nowrap;
}
.v-btn__content > .v-icon--start {
  margin-inline: calc(var(--v-btn-height) / -9) calc(var(--v-btn-height) / 4.5);
}
.v-btn__content > .v-icon--end {
  margin-inline: calc(var(--v-btn-height) / 4.5) calc(var(--v-btn-height) / -9);
}
.v-btn--stacked .v-btn__content {
  white-space: normal;
}

.v-btn__overlay {
  background-color: currentColor;
  border-radius: inherit;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.v-btn__overlay,
.v-btn__underlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.v-card-actions .v-btn ~ .v-btn:not(.v-btn-toggle .v-btn) {
  margin-inline-start: 0.5rem;
}

.v-pagination .v-btn {
  border-radius: 4px;
}
.v-pagination .v-btn--rounded {
  border-radius: 50%;
}
.v-btn__overlay {
  transition: none;
}
.v-pagination__item--is-active .v-btn__overlay {
  opacity: var(--v-border-opacity);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBtn/VBtn.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;EAC7C,mDAAmD;EACnD,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,+DAA+D;EAC/D,0BAA0B;EAC1B,wDAAwD;EACxD,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,uDAAuD;EACzD;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,wOAAwO;AAC1O;AACA;EACE,yOAAyO;AAC3O;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,4CAA4C;EAC5C,uCAAuC;AACzC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;;;EAGE,UAAU;AACZ;AACA;EACE,iDAAiD;EACjD,2BAA2B;EAC3B,uDAAuD;EACvD,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,iBAAiB;EACjB,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,UAAU;EACV,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC","sourcesContent":[".v-btn {\n  align-items: center;\n  border-radius: 4px;\n  display: inline-grid;\n  grid-template-areas: \"prepend content append\";\n  grid-template-columns: max-content auto max-content;\n  font-weight: 500;\n  justify-content: center;\n  letter-spacing: 0.0892857143em;\n  line-height: normal;\n  max-width: 100%;\n  outline: none;\n  position: relative;\n  text-decoration: none;\n  text-indent: 0.0892857143em;\n  text-transform: uppercase;\n  transition-property: box-shadow, transform, opacity, background;\n  transition-duration: 0.28s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  user-select: none;\n  vertical-align: middle;\n  flex-shrink: 0;\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-btn--size-x-small {\n  --v-btn-size: 0.625rem;\n  --v-btn-height: 20px;\n  font-size: var(--v-btn-size);\n  min-width: 36px;\n  padding: 0 8px;\n}\n\n.v-btn--size-small {\n  --v-btn-size: 0.75rem;\n  --v-btn-height: 28px;\n  font-size: var(--v-btn-size);\n  min-width: 50px;\n  padding: 0 12px;\n}\n\n.v-btn--size-default {\n  --v-btn-size: 0.875rem;\n  --v-btn-height: 36px;\n  font-size: var(--v-btn-size);\n  min-width: 64px;\n  padding: 0 16px;\n}\n\n.v-btn--size-large {\n  --v-btn-size: 1rem;\n  --v-btn-height: 44px;\n  font-size: var(--v-btn-size);\n  min-width: 78px;\n  padding: 0 20px;\n}\n\n.v-btn--size-x-large {\n  --v-btn-size: 1.125rem;\n  --v-btn-height: 52px;\n  font-size: var(--v-btn-size);\n  min-width: 92px;\n  padding: 0 24px;\n}\n\n.v-btn.v-btn--density-default {\n  height: calc(var(--v-btn-height) + 0px);\n}\n\n.v-btn.v-btn--density-comfortable {\n  height: calc(var(--v-btn-height) + -8px);\n}\n\n.v-btn.v-btn--density-compact {\n  height: calc(var(--v-btn-height) + -12px);\n}\n\n.v-btn--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-btn--absolute {\n  position: absolute;\n}\n.v-btn--fixed {\n  position: fixed;\n}\n.v-btn:hover > .v-btn__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-btn:focus-visible > .v-btn__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-btn:focus > .v-btn__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-btn--active > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true] > .v-btn__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-btn--active:hover > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true]:hover > .v-btn__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-btn--active:focus-visible > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-btn__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-btn--active:focus > .v-btn__overlay, .v-btn[aria-haspopup=menu][aria-expanded=true]:focus > .v-btn__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-btn--variant-plain, .v-btn--variant-outlined, .v-btn--variant-text, .v-btn--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-btn--variant-plain {\n  opacity: 0.62;\n}\n.v-btn--variant-plain:focus, .v-btn--variant-plain:hover {\n  opacity: 1;\n}\n.v-btn--variant-plain .v-btn__overlay {\n  display: none;\n}\n.v-btn--variant-elevated, .v-btn--variant-flat {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-btn--variant-elevated {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-btn--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-btn--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-btn--variant-text .v-btn__overlay {\n  background: currentColor;\n}\n.v-btn--variant-tonal .v-btn__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n@supports selector(:focus-visible) {\n  .v-btn::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    border: 2px solid currentColor;\n    border-radius: inherit;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n  }\n  .v-btn:focus-visible::after {\n    opacity: calc(0.25 * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-btn--icon {\n  border-radius: 50%;\n  min-width: 0;\n  padding: 0;\n}\n.v-btn--icon.v-btn--size-default {\n  --v-btn-size: 1rem;\n}\n.v-btn--icon.v-btn--density-default {\n  width: calc(var(--v-btn-height) + 12px);\n  height: calc(var(--v-btn-height) + 12px);\n}\n.v-btn--icon.v-btn--density-comfortable {\n  width: calc(var(--v-btn-height) + 0px);\n  height: calc(var(--v-btn-height) + 0px);\n}\n.v-btn--icon.v-btn--density-compact {\n  width: calc(var(--v-btn-height) + -8px);\n  height: calc(var(--v-btn-height) + -8px);\n}\n\n.v-btn--elevated:hover, .v-btn--elevated:focus {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-btn--elevated:active {\n  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-btn--flat {\n  box-shadow: none;\n}\n.v-btn--block {\n  display: flex;\n  flex: 1 0 auto;\n  min-width: 100%;\n}\n.v-btn--disabled {\n  pointer-events: none;\n  opacity: 0.26;\n}\n.v-btn--disabled:hover {\n  opacity: 0.26;\n}\n.v-btn--disabled.v-btn--variant-elevated, .v-btn--disabled.v-btn--variant-flat {\n  box-shadow: none;\n  opacity: 1;\n  color: rgba(var(--v-theme-on-surface), 0.26);\n  background: rgb(var(--v-theme-surface));\n}\n.v-btn--disabled.v-btn--variant-elevated .v-btn__overlay, .v-btn--disabled.v-btn--variant-flat .v-btn__overlay {\n  opacity: 0.4615384615;\n}\n.v-btn--loading {\n  pointer-events: none;\n}\n.v-btn--loading .v-btn__content,\n.v-btn--loading .v-btn__prepend,\n.v-btn--loading .v-btn__append {\n  opacity: 0;\n}\n.v-btn--stacked {\n  grid-template-areas: \"prepend\" \"content\" \"append\";\n  grid-template-columns: auto;\n  grid-template-rows: max-content max-content max-content;\n  justify-items: center;\n  align-content: center;\n}\n.v-btn--stacked .v-btn__content {\n  flex-direction: column;\n  line-height: 1.25;\n}\n.v-btn--stacked .v-btn__prepend,\n.v-btn--stacked .v-btn__append,\n.v-btn--stacked .v-btn__content > .v-icon--start,\n.v-btn--stacked .v-btn__content > .v-icon--end {\n  margin-inline: 0;\n}\n.v-btn--stacked .v-btn__prepend,\n.v-btn--stacked .v-btn__content > .v-icon--start {\n  margin-bottom: 4px;\n}\n.v-btn--stacked .v-btn__append,\n.v-btn--stacked .v-btn__content > .v-icon--end {\n  margin-top: 4px;\n}\n.v-btn--stacked.v-btn--size-x-small {\n  --v-btn-size: 0.625rem;\n  --v-btn-height: 56px;\n  font-size: var(--v-btn-size);\n  min-width: 56px;\n  padding: 0 12px;\n}\n\n.v-btn--stacked.v-btn--size-small {\n  --v-btn-size: 0.75rem;\n  --v-btn-height: 64px;\n  font-size: var(--v-btn-size);\n  min-width: 64px;\n  padding: 0 14px;\n}\n\n.v-btn--stacked.v-btn--size-default {\n  --v-btn-size: 0.875rem;\n  --v-btn-height: 72px;\n  font-size: var(--v-btn-size);\n  min-width: 72px;\n  padding: 0 16px;\n}\n\n.v-btn--stacked.v-btn--size-large {\n  --v-btn-size: 1rem;\n  --v-btn-height: 80px;\n  font-size: var(--v-btn-size);\n  min-width: 80px;\n  padding: 0 18px;\n}\n\n.v-btn--stacked.v-btn--size-x-large {\n  --v-btn-size: 1.125rem;\n  --v-btn-height: 88px;\n  font-size: var(--v-btn-size);\n  min-width: 88px;\n  padding: 0 20px;\n}\n\n.v-btn--stacked.v-btn--density-default {\n  height: calc(var(--v-btn-height) + 0px);\n}\n\n.v-btn--stacked.v-btn--density-comfortable {\n  height: calc(var(--v-btn-height) + -16px);\n}\n\n.v-btn--stacked.v-btn--density-compact {\n  height: calc(var(--v-btn-height) + -24px);\n}\n\n.v-btn--slim {\n  padding: 0 8px;\n}\n.v-btn--rounded {\n  border-radius: 24px;\n}\n.v-btn--rounded.v-btn--icon {\n  border-radius: 4px;\n}\n.v-btn .v-icon {\n  --v-icon-size-multiplier: 0.8571428571;\n}\n.v-btn--icon .v-icon {\n  --v-icon-size-multiplier: 1;\n}\n.v-btn--stacked .v-icon {\n  --v-icon-size-multiplier: 1.1428571429;\n}\n\n.v-btn__loader {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.v-btn__content,\n.v-btn__prepend,\n.v-btn__append {\n  align-items: center;\n  display: flex;\n  transition: transform, opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.v-btn__prepend {\n  grid-area: prepend;\n  margin-inline: calc(var(--v-btn-height) / -9) calc(var(--v-btn-height) / 4.5);\n}\n\n.v-btn__append {\n  grid-area: append;\n  margin-inline: calc(var(--v-btn-height) / 4.5) calc(var(--v-btn-height) / -9);\n}\n\n.v-btn__content {\n  grid-area: content;\n  justify-content: center;\n  white-space: nowrap;\n}\n.v-btn__content > .v-icon--start {\n  margin-inline: calc(var(--v-btn-height) / -9) calc(var(--v-btn-height) / 4.5);\n}\n.v-btn__content > .v-icon--end {\n  margin-inline: calc(var(--v-btn-height) / 4.5) calc(var(--v-btn-height) / -9);\n}\n.v-btn--stacked .v-btn__content {\n  white-space: normal;\n}\n\n.v-btn__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.v-btn__overlay,\n.v-btn__underlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.v-card-actions .v-btn ~ .v-btn:not(.v-btn-toggle .v-btn) {\n  margin-inline-start: 0.5rem;\n}\n\n.v-pagination .v-btn {\n  border-radius: 4px;\n}\n.v-pagination .v-btn--rounded {\n  border-radius: 50%;\n}\n.v-btn__overlay {\n  transition: none;\n}\n.v-pagination__item--is-active .v-btn__overlay {\n  opacity: var(--v-border-opacity);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
